import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './PrintButton.styles'
import { Icon } from '../../atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'

/**
 * functional container for all detail views
 * @returns {*}
 * @constructor
 */
const PrintButton = ({
  label,
  className = '',
  onPrintOpenAll,
  onPrintBtnClicked,
  ...rest
}) => {
  const textContext = useContext(TextContext)

  const clickHandler = () => {
    if (onPrintOpenAll) {
      onPrintOpenAll(true)
    }
    setTimeout(() => {
      window.print()
    }, 300)
  }

  return (
    <Styled.PrintButtonComponent
      { ...rest }
      icon={ <Icon className='icon-f-printer-dark' /> }
      onClick={ onPrintBtnClicked ? onPrintBtnClicked : clickHandler }
      className={ `btn-link ${ className }` }
      text={ label ? label : textContext['general.print'] }
    />
  )
}

PrintButton.defaultPros = {
  onPrintOpenAll: false,
}

PrintButton.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onPrintOpenAll: PropTypes.func,
  onPrintBtnClicked: PropTypes.func,
}

export default PrintButton
